import { render, staticRenderFns } from "./inventory-targets.vue?vue&type=template&id=7ef76c22"
import script from "./inventory-targets.vue?vue&type=script&lang=js"
export * from "./inventory-targets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports